import React from 'react';
import ModalContainer from 'Components/Common/Modal/ModalContainer';
import ModalHeader from 'Components/Common/Modal/ModalHeader';
import ModalBody from 'Components/Common/Modal/ModalBody';
import ModalFooter from 'Components/Common/Modal/ModalFooter';
import ModelItem from './ModelItem';
import { CANCEL, PROMOTE_MODEL, MODELS_TO_PROMOTE, PROMOTE_MESSAGE, YES_PROCEED } from '../ARSConstants';
import { RecommenderLogsResponse } from '../Types';

type TPromoteConfirmDialogProps = {
    showModal: boolean;
    closeModal: () => void;
    onConfirm: () => void;
    loading: boolean;
    selectedItems: RecommenderLogsResponse[];
    handleSelectItemChange: (item: RecommenderLogsResponse) => void;
    id?: string;
}

const PromoteConfirmDialog = ({
    showModal,
    closeModal,
    onConfirm,
    loading,
    handleSelectItemChange,
    selectedItems,
    id
}: TPromoteConfirmDialogProps) => {

    return (
        <ModalContainer id={id} isOpen={showModal} setOpen={closeModal}>
            <ModalHeader>
                <div className="tw-py-1">
                    <h5 className="tw-text-sm tw-font-semibold">{PROMOTE_MODEL}</h5>
                </div>
            </ModalHeader>
            <ModalBody className='!tw-py-0 !tw-px-0'>
                <div className=''>
                    <div className="tw-text-[#6d788c] tw-text-sm tw-px-6 tw-mt-3">{MODELS_TO_PROMOTE}</div>
                    {selectedItems?.map((item: RecommenderLogsResponse) =>
                        <div key={item?._id}>
                            <ModelItem model={item} handleSelectItemChange={handleSelectItemChange} />
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter className='!tw-py-0 !tw-px-0'>
                <div className="tw-w-full tw-h-[121px] tw-bg-[#f4f5f7] tw-rounded-bl tw-rounded-br tw-border tw-border-[#dadbdd]">
                    <label className='tw-text-[#6D788C] tw-text-xs tw-w-[60%] tw-px-6 tw-py-3'>{PROMOTE_MESSAGE}</label>
                    <div className='tw-flex tw-justify-end tw-items-center tw-gap-3 tw-px-6'>
                        <button onClick={closeModal} data-testid="ars-promote-confirm-cancel-btn" className='outline-button'>{CANCEL}</button>
                        <button
                            disabled={selectedItems?.length === 0 || loading}
                            onClick={onConfirm}
                            data-testid="ars-promote-confirm-proceed-btn"
                            className='button-style'
                        >
                            {loading ? 'Promoting...' : YES_PROCEED}
                        </button>
                    </div>
                </div>
            </ModalFooter>
        </ModalContainer>
    );
};

export default PromoteConfirmDialog;
